import { useCallback, useLayoutEffect, useMemo, useState } from 'react';
import { getDuration, useReliableInterval } from '@common-fe/common-fe';
import { toNumber } from 'lodash';

import { SECOND } from '@/common/constants';
import { useResendCodeTimerStore } from '@/modules/user/components/SignIn/stores/useResendCodeTimer.store';

const useResendCodeTimer = () => {
  const [remainingTime, setRemainingTime] = useState(0);
  const { timer, clearTimer } = useResendCodeTimerStore();

  const hasTimer = useMemo(() => !!timer, [timer]);

  const handleUpdateRemainingTime = useCallback((value: number) => {
    const currentRemainingTime = value - 1;
    if (currentRemainingTime <= 0) {
      clearTimer();
    }
    return currentRemainingTime;
  }, [clearTimer]);

  const { start, stop } = useReliableInterval(
    () => setRemainingTime(handleUpdateRemainingTime),
    getDuration({ seconds: 1 })
  );

  useLayoutEffect(() => {
    if (hasTimer) {
      const timeLeftInSeconds = Math.floor((toNumber(timer?.expiredIn) - Date.now()) / SECOND);
      setRemainingTime(timeLeftInSeconds);
    };
  }, [hasTimer, timer]);

  useLayoutEffect(() => {
    if (hasTimer) {
      start();
    }
    return () => {
      stop();
    };
  }, [hasTimer, start, stop]);

  const timeLeft = useMemo(() => hasTimer && remainingTime > 0 ? remainingTime : undefined, [remainingTime, hasTimer]);

  return {
    timeLeft,
  };
};

export default useResendCodeTimer;
